import { utc } from 'moment';
import { Model, AccessorsMutatorsDecorator } from "../../helpers";

/**
 * @class Token
 * @property {string} token
 * @property {string} expired_at
 */
export class Token extends Model {

    get isExpired() {

        return !utc(this.expired_at).isAfter(utc());
    }
}

AccessorsMutatorsDecorator('token', 'expired_at')(Token);


// WEBPACK FOOTER //
// ./src/pms-api/models/token.model.js